import { actions } from '@/store/slices/meeting';
import { AppDispatch } from '@/store/Store';

export const leaveAMeeting =
  (_userID: string, _meetingID: string) => async (dispatch: AppDispatch) => {
    // for now just using local meeting leave
    dispatch(actions.updateCurrentMeetingInfo(null));
  };
